import { Buffer } from 'buffer'

export function delayed<T>(callback, ms: number): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(callback), ms))
}

export const encodeObject = (data: object) => {
  const jsonString = JSON.stringify(data)
  const encodedString = encodeURIComponent(jsonString)
  return Buffer.from(encodedString).toString('base64')
}

export const decodeObject = (data: string) => {
  const decodedString = Buffer.from(data, 'base64').toString('utf8')
  const jsonString = decodeURIComponent(decodedString)
  return JSON.parse(jsonString)
}

export const copyPropertyToClipboard = async (property?: string) => {
  await navigator.clipboard.writeText(property)
}
